import { mapPartToSpeakableScriptPart } from '../../../../learn/mappers/part-to-speakable-script-part.mapper.ts';

import { LessonStep } from '../../../types/asset/lesson.types.ts';
import { LessonTask } from '../../../types/asset/lesson.types.ts';
import { ScriptProcessingResult, SpeakableScriptPart } from '../../../types/asset/script.types.ts';

import { getLessonsUtil } from '../lessons.util.ts';

import { BaseScriptsProcessor } from './base-scripts-processor.ts';

/**
 * This processor is used to process the parts part of a script: "\\(parts)"
 */
export class ScriptsPartsProcessor extends BaseScriptsProcessor {
  public process(part: string, task: LessonTask, step: LessonStep): ScriptProcessingResult {
    if (part === '\\(parts)') {
      const parts = getLessonsUtil().getStepParts(task, step);
      if (parts) {
        const processedParts: SpeakableScriptPart[] = [];
        for (const part of parts) {
          const speakablePart = mapPartToSpeakableScriptPart(part);
          if (speakablePart) {
            processedParts.push(speakablePart);
            continue;
          }
        }
        return { parts: processedParts, processed: true };
      } else {
        this.handleError(new Error('No parts found'), task, step);
        return { parts: [], processed: true };
      }
    }
    return { parts: [], processed: false };
  }
}
